import { render, staticRenderFns } from "./BooleanGroupRule.vue?vue&type=template&id=270e41ba&"
import script from "./BooleanGroupRule.vue?vue&type=script&lang=ts&"
export * from "./BooleanGroupRule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports